import { z } from 'zod';
import { ZipCode, ZipCodeZod } from '../model/Zip';
import { get } from './BaseApi';

const zipCodesZod = z.array(ZipCodeZod);
export async function getZipCodes(): Promise<ZipCode[]> {
  return await get('api/zip/codes', zipCodesZod);
}
